import { StatSegmentRegistry } from '@/types/stats/StatSegmentRegistry.ts';

/** Stany wykonania budżetu, nazwy jak w wyliczeniu backendu. */
export enum BudgetSegmentKey {
  SPENT = 'SPENT',
  COMMITTED = 'COMMITTED',
  AVAILABLE = 'AVAILABLE',
}

export const BUDGET_SEGMENT_REGISTRY: StatSegmentRegistry = {
  [BudgetSegmentKey.SPENT]: { label: 'Wydane', tone: 'success' },
  [BudgetSegmentKey.COMMITTED]: { label: 'Zaplanowane', tone: 'warning' },
  [BudgetSegmentKey.AVAILABLE]: { label: 'Wolne środki', tone: 'neutral' },
};
